export const LANGUAGE_DD = "LANGUAGE_DD"
export const LANGUAGE_DD_SUCCESS = "LANGUAGE_DD_SUCCESS"

